import React from "react";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import { TimelineTitle } from "../../../../Utils/Constants";
import AppIdeasTimeline from "./AppIdeasTimeline";
import BlogTimeline from "./BlogTimeline";
import CarouselTimeline from "./CarouselTimeline";
import AutoTestingTimeline from "./AutoTestingTimeline";
import MeetUpTimeline from "./MeetUpTimeline";
import ResolutionTimeline from "./ResolutionTimeline";
import { timelineMainSubTitle } from "../../../../Data/BonusUiData/TimelineData";

export default function TimelineMain() {
  return (
    <Col sm={12} className="box-col-12">
      <Card>
        <CommonCardHeader title={TimelineTitle} subTitle={timelineMainSubTitle} />
        <CardBody>
          <section className="cd-container cd-timeline" id="cd-timeline">
            <AppIdeasTimeline />
            <BlogTimeline />
            <CarouselTimeline />
            <AutoTestingTimeline />
            <MeetUpTimeline />
            <ResolutionTimeline />
          </section>
        </CardBody>
      </Card>
    </Col>
  );
}
